import { stories } from '@/mocks/stories';
import StoryCard from './StoryCard';

export default function TrendingStories() {
  const featured = stories.slice(0, 6);

  return (
    <section id="trending" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-accent-700">TODAY&apos;S HOT</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">今日大瓜墙</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              按热度排布的六个追踪中的事件，每条都带分类、状态与最近一次更新时间，点开就能顺着时间线往下看。
            </p>
          </div>
          <a
            href="#topics"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            按专题筛选
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((story) => (
            <StoryCard key={story.id} story={story} />
          ))}
        </div>
      </div>
    </section>
  );
}